<template>
  <div class="container">
    <van-nav-bar
      title="使用帮助"
      left-text=""
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="list-box">
      <div class="list" v-if="item.code != 'business-notice'" @click="changePage(item)" :key="index" v-for="(item,index) in dictList">
        <div><span>{{item.name}}</span></div>
        <div><img class="list-arrow" src="../assets/img/sel_right.png" alt=""></div>
      </div>
      <!-- <div class="list" @click="changeNew(1)">
        <div><span>艾来电商户管理制度</span></div>
        <div><img class="list-arrow" src="../assets/img/sel_right.png" alt=""></div>
      </div>
      <div class="list" @click="changeNew(2)">
        <div><span>艾来电商户服务效能评价表</span></div>
        <div><img class="list-arrow" src="../assets/img/sel_right.png" alt=""></div>
      </div> -->
    </div>

    <div class="btnbox">
      <a class="tel" :href="'tel:'+phone">
        <van-button color="#2FAAFF" round block type="info" native-type="submit">客服热线</van-button>
      </a>
    </div>
  </div>
</template>

<script>
  import axios from '@/axios.js';
  import {NavBar,Icon,Toast,Loading,Button} from 'vant';
  export default {
    data() {
      return {
        phone:'',
        dictList:[]
      };
    },
    components: {
      [NavBar.name]:NavBar,
      [Icon.name]:Icon,
      [Toast.name]:Toast, 
      [Loading.name]:Loading,
      [Button.name]:Button,
    },
    methods: {
      changePage(row){
        this.$router.push({path: "helpList.html",query:{code:row.code,title: row.name}})
      },
      changeNew(type){
        if(type ==1){
          window.open('https://soonsmart.keji.io/iopctem/2022-8/10/1660126945316.xlsx');
        }else{
          window.open('https://soonsmart.keji.io/rba/fireware/fwxnpjb.pdf');
        }
      },
      onClickLeft() {
        this.$router.go(-1);
      },
      getTel(){
        axios.get("/center/getservicehotline",{
        }).then((res)=>{
          this.phone = res.data;
        })
      },
      getDictList(){
        axios.get("/dictdetail/getdictdetailchildbydictdetailcode?dictDetailCode=tech-business",{
        }).then((res)=>{
          this.dictList = res.data;
        })
      },
    },
    computed:{
    },
    created () {
      this.getTel();
      this.getDictList();
    },
    mounted () {},
    destroyed () {}
  }
</script>

<style lang="less" scoped>
  body,html{width: 100%;height: 100%;background: #F0F4F7}
  .container{
    width: 100%;height: 100%;letter-spacing:0px;background: #F0F4F7;
  }
  .list-box{
    width: 100%;
    .list{
      height: 60px;
      line-height: 60px;
      width: 100%;
      background: #fff;
      margin: 6px 0;
      padding: 0 15px;
      border-bottom: 1px solid #ECEDEE;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .list-icon{
        width: 30px;
        margin-right: 10px;
        vertical-align: middle;
      }
      .list-arrow{
        width: 10px;
        vertical-align: middle;
      }
    }
  }
  .btnbox{
    width: 100%;
    padding: 0 30px;
    position: fixed;
    left: 0;
    bottom: 40px;
  }
</style>
